import React from 'react';
import { CheckIcon, MailIcon, PrinterIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { BUNDLE_MOCKUP, heroBullets } from '../data/content';
export function Hero() {
  return <header className="border-b border-line bg-cream" data-id="element-113" data-mp="9lla0zpw82ok">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-20" data-id="element-114" data-mp="4lyuukqi8cd4">
        <div className="max-w-3xl" data-id="element-115" data-mp="4njpsbgqdxbi">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.28em] text-accent" data-id="element-116" data-mp="1297ahz3tqr77">
            El Profe de Guitarra
          </p>

          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-117" data-mp="xaxejma9zmkj">
            Planificá todo tu trimestre de clases de guitarra.
          </h1>

          <p className="mt-6 font-display text-xl italic leading-snug text-ink-soft sm:text-2xl" data-id="element-118" data-mp="nbyj55eitnfh">
            El sistema todo-en-uno «Imprimí y enseñá» para profes de guitarra.
          </p>
        </div>

        <figure className="mt-10" data-id="element-119" data-mp="384js0vnybdrc">
          <img src={BUNDLE_MOCKUP} alt="Mockup del método completo: el curso en pantalla junto a los 6 bonos en tablets, atados con un moño de regalo" className="w-full rounded-2xl border border-line bg-paper object-cover shadow-lift" data-id="element-120" data-mp="3j8sg632wlnqw" />
          <figcaption className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs uppercase tracking-eyebrow text-ink-mute" data-id="element-121" data-mp="3e9fs5f0aqamq">
            <PrinterIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-122" data-mp="30hrjxmt646b1" />
            6 volúmenes + 6 bonos · Imprimí copias ilimitadas
          </figcaption>
        </figure>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_minmax(0,26rem)] lg:items-start lg:gap-16" data-id="element-123" data-mp="2qk3lalsfyenl">
          <div data-id="element-124" data-mp="2viokchvyisag">
            <p className="max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-125" data-mp="2vi5558xoyi04">
              Accedé a más de 300 páginas listas para imprimir con ejercicios, rutinas semana a
              semana y herramientas de estudio. Todo es PDF — sin videos, sin audiolibros — y llega
              a tu email en el momento en que lo compras.
            </p>

            <ul className="mt-7 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-126" data-mp="s44ejdlhv3d5">
              {heroBullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-127" data-mp="ic889f9986xu">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-128" data-mp="dd5cklf5zd2j" />
                  <span data-id="element-129" data-mp="1b0vx1kt7peg5">{bullet}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-line bg-paper p-6 shadow-card" data-id="element-130" data-mp="161szsmjh4ciq">
            <CtaButton data-id="element-131" data-mp="15zzvvf08w6ef">¡Sí! Quiero el pack — acceso ahora por $27.990</CtaButton>
            <p className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-ink-mute" data-id="element-132" data-mp="110wq1scfxw5e">
              <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-133" data-mp="x3h2k1o3qghb" />
              Pago seguro
              <span aria-hidden="true" data-id="element-134" data-mp="3lqm3c0xhx9vz">·</span>
              <MailIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-135" data-mp="3hqaian1817jz" />
              PDFs por email
              <span aria-hidden="true" data-id="element-136" data-mp="1xacgb5dntnua">·</span>
              Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </header>;
}